export default __webpack_public_path__ + "static/media/hzs-logob.57d40209.png";